import { Component, inject } from "@angular/core";
import { UiKitModule } from "@app/ui-kit.module";
import { GasWarningCenterConfiguration } from "@domain/project/configurations/gas-warning-center-configuration";
import { FgdsProject } from "@domain/project/fgds-project";
import { Floorplan } from "@domain/project/floorplan/floorplan";
import { ConfiguredProductComponent } from "@project/floorplanner/floorplan-menu/fgds/configured-product/configured-product.component";
import { FloorplanProductMenuComponent } from "@project/floorplanner/floorplan-menu/fgds/floorplan-product-menu/floorplan-product-menu.component";
import { FloorplanService } from "@project/floorplanner/floorplan.service";
import { DraggedItemType, FloorplanDragDropService } from "@utils/floorplan-drag-drop.service";

@Component({
  selector: "app-floorplan-gas-warning-center-menu",
  templateUrl: "./floorplan-gas-warning-center-menu.component.html",
  styleUrls: ["./floorplan-gas-warning-center-menu.component.scss"],
  imports: [UiKitModule, FloorplanProductMenuComponent, ConfiguredProductComponent],
})
export class FloorplanGasWarningCenterMenuComponent {
  private floorplanService = inject(FloorplanService);
  private dragDropService = inject(FloorplanDragDropService);

  protected floorplan: Floorplan;

  protected readonly tooltipTextGasWarningCenters: string = $localize`:@@global.gasWarningCenters:Überwachungsbereich ausblenden`;

  constructor() {
    this.floorplan = this.floorplanService.selectedFloorplan;
  }

  protected get gasWarningCenters(): readonly GasWarningCenterConfiguration[] {
    if (this.floorplan.project instanceof FgdsProject) {
      return this.floorplan.project.gasWarningCenters;
    }
    return [];
  }

  protected addGasWarningCenter(gasWarningCenter: GasWarningCenterConfiguration) {
    this.floorplanService.addGasWarningCenter(gasWarningCenter);
  }

  protected addPlaceholder() {
    this.floorplanService.addGasWarningCenterPlaceholder();
  }

  protected deleteGasWarningCenter(gasWarningCenter: GasWarningCenterConfiguration) {
    (this.floorplan.project as FgdsProject).deleteGasWarningCenter(gasWarningCenter);
  }

  protected drag(gasWarningCenterConfig: GasWarningCenterConfiguration) {
    this.dragDropService.setDragged({ type: DraggedItemType.GAS_WARNING_CENTER, config: gasWarningCenterConfig });
  }

  protected dragPlaceholder() {
    this.dragDropService.setDragged({ type: DraggedItemType.GAS_WARNING_CENTER_PLACEHOLDER });
  }

  protected updateGasWarningCentersItemTextVisibility(visible: boolean) {
    this.floorplan.floorplanState.updateGasWarningCentersItemTextVisibility(visible);
  }
}
